import i18n from 'i18next';

export const NOT_DEFINED = i18n.t('zeus-common.notdefined');

// STATUS
export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const SCHEDULED = 'scheduled';

// DATES
export const DATE_MOMENT_FORMAT = 'llll';

export const DATE_LIST_FORMAT = 'YYYY-MM-DD';

export const DATE_PICKER_FORMAT = 'DD/MM/YYYY';
export const TIME_PICKER_FORMAT = 'HH:mm';

export const DATE_PICKER_PLACEHOLDER = 'DD/MM/YYYY';
export const TIME_PICKER_PLACEHOLDER = 'HH:MM';

// LANGUAGES
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGES = ['en', 'fr', 'es'];
export const LANGUAGE_OPTIONS = [
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
];
export const LANGUAGE_COUNTRIES = {
  ar: 'SA',
  az: 'AZ',
  bg: 'BG',
  bs: 'BA',
  cs: 'CZ',
  da: 'DK',
  de: 'DE',
  el: 'GR',
  en: 'GB',
  'en-GB': 'GB',
  es: 'ES',
  'es-ES': 'ES',
  et: 'EE',
  fi: 'FI',
  fr: 'FR',
  'fr-FR': 'FR',
  he: 'IL',
  hr: 'HR',
  hu: 'HU',
  hy: 'AM',
  id: 'ID',
  is: 'IS',
  'is-IS': 'IS',
  it: 'IT',
  'it-IT': 'IT',
  iw: 'IL',
  ja: 'JP',
  ka: 'GE',
  kk: 'KZ',
  lt: 'LT',
  lv: 'LV',
  'lv-LV': 'LV',
  nl: 'NL',
  no: 'NO',
  pl: 'PL',
  'pt-BR': 'BR',
  'pt-PT': 'PT',
  ro: 'RO',
  ru: 'RU',
  sk: 'SK',
  'sk-SK': 'SK',
  sl: 'SI',
  sr: 'RS',
  tr: 'TR',
  'tr-TR': 'TR',
  uk: 'UA',
  'uk-UA': 'UA',
  zh: 'CN',
  'zh-CN': 'CN',
  'zh-cn': 'CN',
  'zh-Hans': 'CN',
  'zh-hans': 'CN',
  'zh-Hant': 'TW',
  'zh-hant': 'TW',
  'zh-TW': 'TW',
  'zh-tw': 'TW',
};

export const ALL = 'ALL';

export const BASE_APP_IMAGES_URL =
  'https://sport-heroes-assets.s3.amazonaws.com/images/applications/small';

export const PLURAL = 'plural';

export const SINGULAR = 'singular';
